import { setCookie, getCookie, deleteCookie } from "cookies-next";

export const authService = {
  async sendOTP(PhoneNumber: string) {
    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_B2B_API_BASE_URL}/login_number/${PhoneNumber}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error(`Error: ${response.status} ${response.statusText}`);
      const data  = await response.json();
      return data;
    } catch (error) {
      console.error("Failed to send OTP:", error);
      throw error;
    }
  },

  async fetchUserRole(bulkUserID: string | null) {
    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_B2B_API_BASE_URL}/fetch_userRole/${bulkUserID}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error(`Error: ${response.status} ${response.statusText}`);

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch user role:", error);
      throw error;
    }
  },

  async fetchUser(bulkUserID: string | null) {
    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_B2B_API_BASE_URL}/user/${bulkUserID}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error(`Error: ${response.status} ${response.statusText}`);

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch user:", error);
      throw error;
    }
  },

  async verifyOTP(PhoneNumber: string, OTP: string) {
    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_B2B_API_BASE_URL}/login_number_otp/${PhoneNumber}/${OTP}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error(`Error: ${response.status} ${response.statusText}`);

      const data = await response.json();

      // Store token & user info in cookies after successful login
      if (data?.token && data?.PhoneNumber) {
        setCookie("adminToken", data.token, {
          maxAge: 60 * 60 * 24 * 7, // 7 days
          path: "/",
          secure: process.env.NEXT_PUBLIC_NODE_ENV === "production",
          httpOnly: false,
        });

        setCookie("adminPhone", data.PhoneNumber, {
          maxAge: 60 * 60 * 24 * 7,
          path: "/",
          secure: process.env.NEXT_PUBLIC_NODE_ENV === "production",
          httpOnly: false,
        });

        setCookie("adminExists", data.UserExists, {
          maxAge: 60 * 60 * 24 * 7,
          path: "/",
          secure: process.env.NEXT_PUBLIC_NODE_ENV === "production",
          httpOnly: false,
        });

        if (data?.UserID) {
          setCookie("adminUserID", data.UserID, {
            maxAge: 60 * 60 * 24 * 7,
            path: "/",
            secure: process.env.NEXT_PUBLIC_NODE_ENV === "production",
            httpOnly: false,
          });
        }

        if (data?.creditLimit) {
          setCookie("adminCreditLimit", data.creditLimit, {
            maxAge: 60 * 60 * 24 * 7,
            path: "/",
            secure: process.env.NEXT_PUBLIC_NODE_ENV === "production",
            httpOnly: false,
          });
        }
      }

      return data;
    } catch (error) {
      console.error("OTP verification failed:", error);
      throw error;
    }
  },

  logout() {
    deleteCookie("adminToken");
    deleteCookie("adminPhone");
    deleteCookie("adminExists");
    deleteCookie("adminUserID");
    deleteCookie("adminCreditLimit");
  },

  getToken() {
    return getCookie("adminToken");
  },
};
